var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87818 7.99886L15.606 2.28357C16.1283 1.76117 16.1283 0.914198 15.606 0.391799C15.0837 -0.1306 14.2368 -0.1306 13.7145 0.391799L8 6.12041L2.28552 0.391799C1.7632 -0.1306 0.916342 -0.1306 0.394017 0.391799C-0.128308 0.914198 -0.128308 1.76117 0.394017 2.28357L6.12182 7.99886L0.394017 13.7142C0.141844 13.9643 0 14.3048 0 14.66C0 15.0153 0.141844 15.3558 0.394017 15.6059C0.644131 15.8581 0.984596 16 1.33977 16C1.69494 16 2.03541 15.8581 2.28552 15.6059L8 9.87731L13.7145 15.6059C13.9646 15.8581 14.3051 16 14.6602 16C15.0154 16 15.3559 15.8581 15.606 15.6059C15.8582 15.3558 16 15.0153 16 14.66C16 14.3048 15.8582 13.9643 15.606 13.7142L9.87818 7.99886Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.7e7cbb905e15d59046eb6af1ba6d7df9.svg";
export { ForwardRef as ReactComponent };